export default "__VITE_ASSET__B$tcag3o__"